import {BeginSealDeviceMethodInterceptor} from "@hybird/device/interceptor/beginSeal/core";
import {defaultError, WebError} from "@hybird/core/error";
import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {config} from "@hybird/device/config";
import {DeviceBeginSealType, DeviceEvent} from "@hybird/core/device/protocol";
import {delay} from "@hybird/core/lib";

export class BeforeSealPhotoBeginSealInterceptor extends BeginSealDeviceMethodInterceptor {
  async equipmentLock(proceed, self, params = {}) {
    if (!params.before) {
      throw WebError.code(defaultError.ILLEGAL_ARGUMENT, {
        msg: "用印前拍照, 必须传入before参数"
      })
    }

    //调用当前的用印前拍照的流程
    self.context.data.before = params.before;
    self.context.data.after = params.after;

    const result = await proceed(params);

    const beforeUpload = async (data) => {
      result.exec = async () => {
        return result.examineResult({state: 1});
      };

      if (self.deviceInfo.sealAuthenticationExamine === 2) {
        result.isSeal = 1;

        self.remoteLockStatus = self.deviceProtocol.version >= 3;

        return result;
      }

      return data;
    }

    result.upload = result.upload ? result.upload.andThen(beforeUpload) : beforeUpload

    return result
  }

  async contextReset(proceed, self, send) {
    try {
      if (self.deviceInfo.afterSealSnap === 1 && send) {
        console.log("BeforeSealPhotoBeginSealInterceptor", "用印后前置回调", self.deviceInfo.leftTimes)
        await self.context.data.after?.(1);
        await delay(self.deviceInfo.snapInterval);
        console.log("BeforeSealPhotoBeginSealInterceptor", "用印后后置回调", self.deviceInfo.leftTimes)
        await self.context.data.after?.(2);
      }
    } catch (e) {
      console.warn("用印后抓拍异常", e);
    }

    return await proceed(send);
  }

  async examineResult(proceed, self, documentRemoteId, state, params) {
    //当开启用印前时, 释放次数后补拍用印前
    if (state === 1 && self.deviceInfo.beforeSealPhoto === 1) {
      await new Promise((resolve, reject) => {
        const uploadBefore = ({fileId, isScannerUpload = false, data = {}}) => {
          return service.post(url.ocr, {
            'documentId': self.deviceInfo.documentId,
            'fileUserIds': fileId,
            'sealId': self.deviceInfo.sealId,
            isScannerUpload,
            'fileInfo': {
              address: config.address, lon: config.gps.lon, lat: config.gps.lat
            },
            ...data,
          }).catch(reject).then(data => {
            resolve();
            return data;
          });
        }

        if (self.context.data.picture) {
          uploadBefore({fileId: self.context.data.picture});
        } else if (!self.context.data.uploadBefore) {
          self.context.data.before(async ({fileId, isScannerUpload = false, data = {}}) => {
            if (!(fileId instanceof Array)) {
              fileId = [fileId];
            }

            return uploadBefore({fileId, isScannerUpload, data});
          });
        } else {
          resolve();
        }
      })
    }

    return await proceed(documentRemoteId, state, params);
  }


  isSupport(self) {
    return (self.deviceInfo.beforeSealPhoto === 1 || self.deviceInfo.afterSealSnap === 1) && self.deviceInfo.remote !== DeviceBeginSealType.remote;
  }

  get order() {
    return -50;
  }
}

